import { useState } from "react";
import style from "../styles/checkout-pages.module.scss";
import { BottomSpacer } from "../components/spacer";

const MOCK_ITEM = {
  productName: "EICR Guaranteed Pass",
  bookingID: "PREVIEW-1234567890",
  customerName: "Jane Smith",
  emailDate: "Monday 28th April 2026",
  emailStartTime: "8:00 AM",
  emailEndTime: "1:00 PM",
  address: { line1: "12 Example Street", postcode: "EC1A 1BB" },
  finalPrice: 149,
};

function SuccessIcon() {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="#16a34a" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
      <polyline points="20 6 9 17 4 12" />
    </svg>
  );
}

function FailIcon() {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="#dc2626" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
      <line x1="18" y1="6" x2="6" y2="18" />
      <line x1="6" y1="6" x2="18" y2="18" />
    </svg>
  );
}

function SuccessPreview() {
  const item = MOCK_ITEM;
  return (
    <div className={style.page} style={{ minHeight: "auto", padding: "40px 20px" }}>
      <div className={style.card}>
        <div className={style.iconWrapSuccess}>
          <SuccessIcon />
        </div>
        <h1 className={style.heading}>Payment Confirmed</h1>
        <p className={style.subheading}>
          Thanks for your booking — your payment went through successfully.
        </p>
        <div className={style.divider} />
        <div className={style.detailsGrid}>
          <div className={style.detailRow}>
            <span className={style.detailLabel}>Service</span>
            <span className={style.detailValue}>{item.productName}</span>
          </div>
          <div className={style.detailRow}>
            <span className={style.detailLabel}>Booking ID</span>
            <span className={style.detailValue}>{item.bookingID}</span>
          </div>
          <div className={style.detailRow}>
            <span className={style.detailLabel}>Name</span>
            <span className={style.detailValue}>{item.customerName}</span>
          </div>
          <div className={style.detailRow}>
            <span className={style.detailLabel}>Date</span>
            <span className={style.detailValue}>{item.emailDate}</span>
          </div>
          <div className={style.detailRow}>
            <span className={style.detailLabel}>Time</span>
            <span className={style.detailValue}>{item.emailStartTime} – {item.emailEndTime}</span>
          </div>
          <div className={style.detailRow}>
            <span className={style.detailLabel}>Address</span>
            <span className={style.detailValue}>{item.address.line1}, {item.address.postcode}</span>
          </div>
          <div className={style.detailRow}>
            <span className={style.detailLabel}>Amount paid</span>
            <span className={style.detailValue}><span className={style.badge}>£{item.finalPrice}</span></span>
          </div>
        </div>
        <p className={style.emailNote}>
          A confirmation email is on its way to you. If you don't see it, check your junk folder.
        </p>
        <div className={style.actions}>
          <button className={style.primaryBtn}>Book another service</button>
          <a href="/contact-us" className={style.secondaryLink}>Need help? Contact us</a>
        </div>
      </div>
    </div>
  );
}

function FailPreview() {
  return (
    <div className={style.page} style={{ minHeight: "auto", padding: "40px 20px" }}>
      <div className={style.card}>
        <div className={style.iconWrapFail}>
          <FailIcon />
        </div>
        <h1 className={style.heading}>Payment Unsuccessful</h1>
        <p className={style.subheading}>
          We weren't able to process your payment. Your card has not been charged.
        </p>
        <div className={style.divider} />
        <p className={style.failNote}>
          This can happen if your card was declined, your session timed out, or you cancelled at checkout. Please try again or contact your payment provider if the issue continues.
        </p>
        <div className={style.actions}>
          <button className={style.primaryBtn}>Try again</button>
          <a href="/contact-us" className={style.secondaryLink}>Need help? Contact us</a>
        </div>
      </div>
    </div>
  );
}

export default function CheckoutPreview() {
  const [view, setView] = useState<"success" | "fail">("success");

  return (
    <div style={{ paddingTop: "80px" }}>
      {/* Toggle bar */}
      <div style={{
        display: "flex",
        justifyContent: "center",
        gap: "12px",
        padding: "16px 20px",
        background: "#f9fafb",
        borderBottom: "1px solid #e5e7eb",
        position: "sticky",
        top: "75px",
        zIndex: 100,
      }}>
        <span style={{ fontSize: "0.8rem", color: "#6b7280", alignSelf: "center", fontWeight: 600 }}>
          PREVIEW:
        </span>
        <button
          onClick={() => setView("success")}
          style={{
            padding: "8px 20px",
            borderRadius: "50px",
            border: "none",
            cursor: "pointer",
            fontWeight: 700,
            fontSize: "0.85rem",
            background: view === "success" ? "#16a34a" : "#e5e7eb",
            color: view === "success" ? "#fff" : "#374151",
            transition: "all 0.2s",
          }}
        >
          ✓ Success
        </button>
        <button
          onClick={() => setView("fail")}
          style={{
            padding: "8px 20px",
            borderRadius: "50px",
            border: "none",
            cursor: "pointer",
            fontWeight: 700,
            fontSize: "0.85rem",
            background: view === "fail" ? "#dc2626" : "#e5e7eb",
            color: view === "fail" ? "#fff" : "#374151",
            transition: "all 0.2s",
          }}
        >
          ✕ Failed
        </button>
      </div>

      {view === "success" ? <SuccessPreview /> : <FailPreview />}
      <BottomSpacer />
    </div>
  );
}
